const useCalculateMembershipTotalPrice = (): ((membership: MemberShipDataTypes) => number) => {
  return (membership: MemberShipDataTypes): number => {
    if (membership.divisiondata.length === 0) {
      return membership.basicprice;
    }

    if (!membership.editable && ![2, 4, 5].includes(membership.paymenttypeidx)) {
      let totalPrice = membership.basicprice + membership.divisionprice;

      return totalPrice;
    }

    let totalPrice = membership.basicprice;

    if (![2, 4, 5].includes(membership.paymenttypeidx)) {
      membership.divisiondata.forEach((item) => {
        if (item.recommendyn) {
          totalPrice += item.tidprice;
        }
      });
    }

    return totalPrice;
  };
};

export default useCalculateMembershipTotalPrice;
